var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-lg text-center mx-0 my-auto md:text-2xl lg:text-3xl"},[_c('div',{staticClass:"px-2 m-auto md:px-20 lg:px-40 prose prose-lg",domProps:{"innerHTML":_vm._s(_vm.htmlText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }